import React, { Fragment } from 'react';
import {
  Route,
  Routes
} from 'react-router-dom'
import './App.css';

import BannerComponent from './BannerComponent/BannerComponent'
import FeatureComponent from './FeatureComponent/FeatureComponent'
import FooterComponent from './FooterComponent/FooterComponent';
import HeaderComponent from './HeaderComponent/HeaderComponent';

const App = () => {
  return (
    <div>
      <HeaderComponent/> 
      <Routes>
        <Fragment>
          <Route path="/" element={ <BannerComponent />}/>
          <Route path="/tarrif-details/:vehicleName" element={ <FeatureComponent />}/>
        </Fragment>
      </Routes>
      {/* <FooterComponent/> */}
    </div>
  );
}

export default App;


